// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__9erx0","line":"Divider_line__OtieH","hr":"Divider_hr__SYOt6","text":"Divider_text__t07ci"};